<ul>
  <li>
    <a [href]="urlSlPlusSupport" target="_blank">
      Contactez-nous
    </a>
  </li>
  <li>
    <a [href]="urlLegalInfos" target="_blank">
      Mentions légales
    </a>
  </li>
  <li>
    <a [href]="urlTOU" target="_blank">
      Conditions générales d'utilisation
    </a>
  </li>
  <li>
    <a [href]="urlRecruitment" target="_blank">
      Groupe SeLoger.com
    </a>
  </li>
  <li>
    <a
      (click)="showCookies()"
      style="cursor: pointer; text-decoration: underline" 
    >
      Paramétrer mes cookies
    </a>
  </li>
</ul>
